<template lang="pug">
    .ui-content__item-page.ui-alert.ui-item-page
        h2.ui-item-page__title UI Alert
        .ui-block
            .row
                .col-lg-1
                    h5.ui-item-page__sub-title Basic
                    vue-checkbox(v-model='checked') Option
                .col-lg-2
                    h5.ui-item-page__sub-title Disabled State
                    vue-checkbox(v-model='checked1', disabled='') Option
                    vue-checkbox(v-model='checked2', disabled='') Option
                .col-lg-5
                    h5.ui-item-page__sub-title Checkbox group
                    vue-checkbox-group(v-model='checkList')
                        vue-checkbox(label='Option A')
                        vue-checkbox(label='Option B')
                        vue-checkbox(label='Option C')
                        vue-checkbox(label='disabled', disabled='')
                        vue-checkbox(label='selected and disabled', disabled='')
        .ui-block
            .row
                .col-lg-4
                    h5.ui-item-page__sub-title Indeterminate
                    vue-checkbox(:indeterminate='isIndeterminate', v-model='checkAll', @change='handleCheckAllChange') Check all
                    div(style='margin: 15px 0;')
                    vue-checkbox-group(v-model='checkedCities', @change='handleCheckedCitiesChange')
                        vue-checkbox(v-for='city in cities', :label='city', :key='city') {{city}}
                .col-lg-4
                    h5.ui-item-page__sub-title Minimum / Maximum items checked
                    vue-checkbox-group(v-model='checkedCities1', :min='1', :max='2')
                        vue-checkbox(v-for='city in cities', :label='city', :key='city') {{city}}
        .ui-block
            .row
                .col-lg-4
                    h5.ui-item-page__sub-title Button style
                    div
                        vue-checkbox-group(v-model='checkboxGroup1')
                            vue-checkbox-button(v-for='city in cities', :label='city', :key='city') {{city}}
                        div(style='margin-top: 20px')
                            vue-checkbox-group(v-model='checkboxGroup2', size='medium')
                                vue-checkbox-button(v-for='city in cities', :label='city', :key='city') {{city}}
                        div(style='margin-top: 20px')
                            vue-checkbox-group(v-model='checkboxGroup3', size='small')
                                vue-checkbox-button(v-for='city in cities', :label='city', :disabled="city === 'Beijing'", :key='city') {{city}}
                        div(style='margin-top: 20px')
                            vue-checkbox-group(v-model='checkboxGroup4', size='mini', disabled='')
                                vue-checkbox-button(v-for='city in cities', :label='city', :key='city') {{city}}
                .col-lg-4
                    h5.ui-item-page__sub-title Button style With borders
                    div
                        vue-checkbox(v-model='checked3', label='Option1', border)
                        vue-checkbox(v-model='checked4', label='Option2', border)
                    div(style='margin-top: 20px')
                        vue-checkbox(v-model='checked5', label='Option1', border, size='medium')
                        vue-checkbox(v-model='checked6', label='Option2', border, size='medium')
                    div(style='margin-top: 20px')
                        vue-checkbox-group(v-model='checkboxGroup5', size='small')
                            vue-checkbox(label='Option1', border)
                            vue-checkbox(label='Option2', border, disabled)
                    div(style='margin-top: 20px')
                        vue-checkbox-group(v-model='checkboxGroup6', size='mini', disabled)
                            vue-checkbox(label='Option1', border)
                            vue-checkbox(label='Option2', border)


</template>
<script>
    import vueCheckbox from "../checkbox/checkbox.vue"
    import vueCheckboxGroup from "../checkbox-group/checkbox-group.vue"
    import vueCheckboxButton from "../checkbox-button/checkbox-button.vue"
    const cityOptions = ['Shanghai', 'Beijing', 'Guangzhou', 'Shenzhen'];
    export default {
        data() {
            return {
                checked: true,
                checked1: false,
                checked2: true,
                checkList: ['selected and disabled','Option A'],
                checkAll: false,
                checkedCities: ['Shanghai', 'Beijing'],
                cities: cityOptions,
                isIndeterminate: true,
                checkedCities1: ['Shanghai', 'Beijing'],
                checkboxGroup1: ['Shanghai'],
                checkboxGroup2: ['Shanghai'],
                checkboxGroup3: ['Shanghai'],
                checkboxGroup4: ['Shanghai'],
                checked3: true,
                checked4: false,
                checked5: false,
                checked6: true,
                checkboxGroup5: [],
                checkboxGroup6: []
            };
        },
        methods: {
            handleCheckAllChange(val) {
                this.checkedCities = val ? cityOptions : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
            }
        },
        components: {
            vueCheckbox,
            vueCheckboxGroup,
            vueCheckboxButton
        }
    };
</script>